import React from "react";

class PreviewImage extends React.Component {
  render() {
    const { imageUrl, previewImage, width, height } = this.props;
    return (
      <div>
        <img
          alt="Loading respective marketplace logo"
          src={previewImage || imageUrl}
          style={{
            objectFit: "cover",
            width: width || "auto",
            height: height || "auto"
          }}
        />
      </div>
    );
  }
}

export default PreviewImage;
